import classNames from "classnames/bind";
import { Label } from "common/components/forms/Label";
import * as React from "react";
import { UseFormRegisterReturn } from "react-hook-form/dist/types/form";
import styles from "./InputField.module.css";

const classNameBuilder = classNames.bind(styles);

// TODO: Add more props when needed
interface Props {
  disabled?: boolean;
  register: UseFormRegisterReturn;
  id: string;
  placeholder?: string;
  type?: string;
  kind?: "large" | "medium" | "normal";
  title?: string;
}

export const InputField: React.FC<React.PropsWithChildren<Props>> = ({
  disabled = false,
  register,
  id,
  placeholder = "",
  type = "text",
  kind = "normal",
  title,
}) => {
  const classes = classNameBuilder({
    large: kind === "large",
    medium: kind === "medium",
    normal: kind === "normal",
  });

  return (
    <>
      {title && <Label htmlFor={id} title={title} />}
      <input
        className={classes}
        id={id}
        type={type}
        ref={register.ref}
        name={register.name}
        disabled={disabled}
        placeholder={placeholder}
        onChange={register.onChange}
        onBlur={register.onBlur}
      />
    </>
  );
};
